export default {
  table: {
    sortByColumn: 'Ordenar por {{column}}',
  },
};
